import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Grid,
  Box,
  Typography,
} from '@material-ui/core';

import CurrencySelector from '@pro/web-common/components/currency-selector-home';

import { DEFAULT_CURRENCY_ID } from 'constants/currency';
import { PLAN_TYPE_SINGLE_ID, PLAN_TYPE_FREE_ID, PLAN_TYPE_MULTI_TEN_ID } from 'constants/subscriptions-config';

import PlanItem from './plan-item';


const PricingSection = React.memo(({ isSignIn }) => {
  const [currencyId, setCurrencyId] = useState(DEFAULT_CURRENCY_ID);

  return (
    <Box
      bgcolor="primary.additional"
      color="dark"
      pt={8}
      pb={8}
      id="pricing"
    >
      <Container maxWidth="md">
        <Box
          textAlign="center"
          mb={3}
        >
          <Typography
            variant="h3"
          >
            Easy pricing.
          </Typography>
        </Box>

        <Box
          textAlign="center"
          mb={3}
        >
          <CurrencySelector
            currencyId={currencyId}
            onChange={setCurrencyId}
          />
        </Box>

        <Grid
          container
          justify="space-between"
          spacing={8}
        >
          <Grid
            item
            xs={12}
            sm={4}
          >
            <PlanItem
              title="Self Service"
              features={[
                'Brand colors, fonts & images',
                '1 x Digital Menu Builder',
                'ANY ordering/table booking',
                'Limited Push Messaging',
                'Limited Image Messaging',
                'Print Ready POS & Posters',
                'Limited support',
                'Loads more features',
              ]}
              buttonText="FREE PLAN"
              opacity={0.3}
              planId={PLAN_TYPE_FREE_ID}
              currencyId={currencyId}
              isSignIn={isSignIn}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={4}
          >
            <PlanItem
              title="Upgrade"
              features={[
                'Brand colors, fonts & images',
                'Digital Menu Builder',
                'ANY ordering/table booking',
                'Push Messaging',
                'Image Messaging',
                'Print Ready POS',
                'Optional Upsell Planning',
                'Optional Online Training',
                'Unlimited 24/7 support',
                'Loads more features',
              ]}
              opacity={0.5}
              planId={PLAN_TYPE_SINGLE_ID}
              currencyId={currencyId}
              isSignIn={isSignIn}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={4}
          >
            <PlanItem
              title="ENTERPRISE"
              features={[
                'Per 10 properties',
                'Brand colors, fonts & images',
                'Digital Menu Builder',
                'ANY ordering/table booking',
                'Push Messaging',
                'Image Messaging',
                'Print Ready POS',
                'Optional Upsell Planning',
                'Optional Online Training',
                'Unlimited 24/7 support',
                'Loads more features',
              ]}
              opacity={0.3}
              planId={PLAN_TYPE_MULTI_TEN_ID}
              currencyId={currencyId}
              isSignIn={isSignIn}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
});


PricingSection.propTypes = {
  isSignIn: PropTypes.bool.isRequired,
};

PricingSection.defaultProps = {};


export default PricingSection;
